<template>
  <div class="pull-right">
    <van-tag v-if="formattedMt.isPeriodic" type="success" plain>周期</van-tag>
    <van-tag type="primary" plain class="mar-lft-5">{{formattedMt.mode}}</van-tag>
    <van-tag class="mar-lft-5" :type="formattedMt.statusStyle">{{formattedMt.statusCN}}</van-tag>
  </div>
</template>

<script>
  export default {
    props: {
      formattedMt: Object,
    },
  }
</script>

<style scoped>
</style>
